import { useEffect, useState } from 'react';
import { emitChange, off, subscribe } from '../helpers/subscription';
import { globalState } from '../internal/stateContainer';
/**
 * @deprecated Use `useSelector` instead. Avoid listening to the entire global state, it will cause uneeded re-renders.
 */
export var useGlobalState = function () {
    var _a = useState(function () { return globalState; }), localeGlobalState = _a[0], setLocaleGlobalState = _a[1];
    useEffect(function () {
        var subscription = subscribe(setLocaleGlobalState);
        return function () {
            off(subscription);
        };
    }, []);
    return { globalState: localeGlobalState, setGlobalState: emitChange };
};
//# sourceMappingURL=useGlobalState.js.map